import loginConfig from './login';

export default {
  ...loginConfig,
};



// WEBPACK FOOTER //
// ./src/widget/analytics/bi/action-handlers/all.js